/** Mapper para asociar códigos de dirección de carretera con sus descripciones */
export function mapDirectionCode(code: string | undefined | null): string {
  switch (code) {
    case 'N':
      return 'Ascendente';
    case 'S':
      return 'Descendente';
    case 'B':
      return 'Ambos sentidos';
    default:
      return '';
  }
}
